<div class="search-bar" [ngClass]="{'active': active, 'cart': cartSearch}" (mousedown)="onClick($event)" data-test="search-bar-component">
  <div class="search-field">
    @if (cartSearch) {
      <span class="icon-search"></span>
    }
    <input
        id="searchInput"
        name="search"
        type="search"
        class="search-bar__input"
        spellcheck="false"
        autocomplete="off"
        [disabled]="disabled"
        [value]="query"
        placeholder="{{ 'app-bar.search-placeholder' + (cartSearch ? '-cart' : '') | translate }}"
        (keyup)="onKey($event)"
        (click)="toggleSearch()"
        [attr.data-test]="cartSearch ? 'input-searchBarInCartPage' : 'input-searchBar-in-header'"/>
    @if (hasValue() && !disabled) {
      <label for="searchInput" class="action-icons">
        @if (loading) {
          <span class="loading-animation"></span>
        }
        @if (!loading) {
          <span class="search-bar__remove icon-close" (click)="clearQuery()" [attr.data-test]="'button-remove-input-from-searchBar'"></span>
        }
      </label>
    }
    @if (!cartSearch) {
      <button type="button" class="search-bar__btn-search" [disabled]="!hasValue()"
              (click)="proceedToSearchPage(query)"
              [attr.data-test]="'button-searchBar-search'">
        <span class="icon-search"></span>
      </button>
    }
  </div>
  @if (hasValue() && !loading && active) {
    <div class="search-results" [ngClass]="{'cart': cartSearch}">
      @if (hasSuggestions()) {
        @for (key of suggestionsKeys(); track key) {
          @if (suggestions[key].length > 0 && visibleResults.includes(key)) {
            @if (suggestionTitle.includes(key) && !cartSearch) {
              <span class="suggestion__title">
                {{ 'app-bar.suggestion-' + key | translate }}
              </span>
            }
            <ul
                class="suggestions__list"
                [ngClass]="{'has-title': suggestionTitle.includes(key)}"
                [attr.data-test]="'search-suggestions-list'">
              @for (suggestion of suggestions[key]; track $index; let i = $index) {
                @if (key === 'categories' && !cartSearch) {
                  @if (i < maxResultsPerSuggestion) {
                    <li
                        [ngClass]="['suggestion', 'suggestion-'+key]"
                        [innerHTML]="boldString(suggestion.name, query)"
                        (click)="proceedToCategoryPage(suggestion)"
                        [attr.data-test]="'item-suggestionCategories-' + suggestion.name">
                    </li>
                  }
                }
                @if (key === 'completion' && !cartSearch) {
                  @if (i < maxResultsPerSuggestion) {
                    <li
                        [ngClass]="['suggestion', 'suggestion-'+key]"
                        [innerHTML]="boldString(suggestion, query)"
                        (click)="proceedToSearchPage(suggestion)"
                        [attr.data-test]="'item-suggestionCompletion-' + suggestion">
                    </li>
                  }
                }
                @if (key === 'abstractProducts') {
                  @if (suggestion.abstractName && i < maxResultsPerSuggestion) {
                    <li
                        [ngClass]="['suggestion', 'suggestion-'+key]"
                        (click)="proceedToProductPage(suggestion)"
                        [attr.data-test]="'item-suggestionAbstractProduct-' + suggestion.abstractName">
                      <span [innerHTML]="boldString(
                        getCartSearchSuggestion(suggestion), query)"></span>
                    </li>
                  }
                }
              }
            </ul>
            @if (!cartSearch) {
              <hr class="suggestions__underline">
            }
          }
        }
      }
      @if (!hasSuggestions() && hasValue()) {
        <div class="no-result-found">
          {{ 'app-bar.no-result-found' | translate }}
        </div>
      }
    </div>
  }
</div>
